// @mui
import { Box, BoxProps } from '@mui/material';
import { forwardRef, ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import LoadingGuard from 'src/guards/LoadingGuard';

// ----------------------------------------------------------------------

interface PageProps extends BoxProps {
  children: ReactNode;
  title?: string;
}

const Page = forwardRef<HTMLDivElement, PageProps>(({ children, title = '', ...other }, ref) => (
  <LoadingGuard>
    <Box ref={ref} {...other}>
      <Helmet>
        <title>{`Mist | ${title}`}</title>
      </Helmet>
      {children}
    </Box>
  </LoadingGuard>

));

export default Page;
